// The GUEST side of sign-in (see pages/login and pages/guestHome).
//
// Who is a guest: a known number that is not staff of the event — an Evt_Users
// row without any organiser/event mapping, or a number on the event's guest
// list (the API decides: IdentifyEventUser). A guest proves the number with a
// WhatsApp OTP, gets an Evt_Users row if they had none (GuestSignIn), and then
// uses the guest screen of ONE event: their invitations + RSVP, and adding the
// people they want to bring (saved with CreatedBy = their UserId).
//
// The guest session is separate from the staff session in AuthContext: it has
// no password, no organiser and no device binding, so none of the app shell,
// DeviceGuard or permission code ever sees it. Stored in localStorage se_guest.

// The event guests sign in to. Only "Sahil weds Diksha" for now (EventId 2);
// a build can point elsewhere with REACT_APP_GUEST_EVENT_ID.
export const GUEST_EVENT_ID = Number(process.env.REACT_APP_GUEST_EVENT_ID || 2);

const KEY = 'se_guest';

// { user, event, side, mobile }
export function getGuestSession() {
  try {
    const s = JSON.parse(localStorage.getItem(KEY));
    return s && s.user && s.event ? s : null;
  } catch { return null; }
}
export function setGuestSession(session) {
  try { localStorage.setItem(KEY, JSON.stringify(session)); } catch { /* private mode: session lasts this page only */ }
}
export function clearGuestSession() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
